export const baseColumnList = () => {
  return [
    {
      field: 'contractMatterName',
      title: '合同标的',
      editRender: { name: 'contractMatterName' },
    },
    {
      field: 'isFixedPrice',
      title: '是否定价',
      showHeaderOverflow: true,
      editRender: { name: 'isFixedPrice' },
    },
    {
      field: 'unit',
      title: '单位',
      showHeaderOverflow: true,
      editRender: { name: 'unit' },
    },
    {
      field: 'productQuantity',
      title: '交货数量',
      editRender: { name: 'productQuantity' },
    },
  ];
};

const checkPrice = (rule, value, callback) => {
  if (!value || !value.length) {
    callback();
    return;
  }
  let reg = /1?(\d|([1-9]\d+))(.\d{0,6})?$/;
  if (!reg.test(value)) {
    callback(new Error('数字格式不正确'));
    return;
  }
  callback();
};

export const baseTableRule = () => {
  return {
    isFixedPrice: [{ required: true, message: '必填字段', trigger: 'change' }],
    // contractMatter: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractMatterName: [{ required: true, message: '必填字段', trigger: ['blur', 'change'] }],
    productQuantity: [
      // { required: true, message: '必填字段', trigger: 'blur' },
      { validator: checkPrice },
    ],
    yearProductQuantity: [
      { required: true, message: '必填字段', trigger: 'blur' },
      { validator: checkPrice },
    ],
  };
};
